<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['view_loanapplications'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="mb-0">Credit Scoring Calculator</h4><small class="d-block text-primary">Fill this information
              about a member to assess
              their
              creditworthiness</small>
            <hr>
            <div class="row">
              <div class="col-7 pe-5">
                <div class="row mb-3">
                  <v-select :disabled="backToLoanApplication" :options="members" placeholder="Select Member"
                    v-model="member" label="name"></v-select>
                </div>
                <div class="row">
                  <div class="col-6 mb-3">
                    <label class="mb-0" for="loan-repay">Loan Repayment History</label>
                    <select v-model="loan_repayment" id="loan-repay" class="form-select">
                      <option value="35">On-Time Payments</option>
                      <option value="30">1-30 Days late</option>
                      <option value="20">31-60 Days late</option>
                      <option value="0">Defaults</option>
                      <option selected value="0">No Loan History</option>
                    </select>
                  </div>
                  <div class="col-6 mb-3">
                    <label class="mb-0" for="loan-repay">Saving History</label>
                    <select v-model="saving" id="loan-repay" class="form-select">
                      <option value="15">Consistent Savings</option>
                      <option value="10">Occassional Missed</option>
                      <option value="5">Irregular Savings</option>
                      <option selected value="0">No Saving History</option>
                    </select>
                  </div>
                  <div class="col-6 mb-3">
                    <label class="mb-0" for="loan-repay">Character Assessment</label>
                    <select v-model="character" id="loan-repay" class="form-select">
                      <option value="15">Hightly Trusted</option>
                      <option value="10">Moderately Trusted</option>
                      <option value="5">Low Trust</option>
                      <option selected value="0">Not Trusted</option>
                    </select>
                  </div>
                  <div class="col-6 mb-3">
                    <label class="mb-0" for="loan-repay">Capacity to Repay</label>
                    <select v-model="capacity" id="loan-repay" class="form-select">
                      <option value="15">Stable Income</option>
                      <option value="10">Variable Income</option>
                      <option value="5">Unstable Income</option>
                      <option selected value="0">No Income Evidence</option>
                    </select>
                  </div>
                  <div class="col-6 mb-3">
                    <label class="mb-0" for="loan-repay">Membership Period</label>
                    <select v-model="membership" id="loan-repay" class="form-select">
                      <option value="5">5+ Years</option>
                      <option value="4">2 - 5 year Membership</option>
                      <option value="2">1 - 2 year Membership</option>
                      <option selected value="0">&lt; 1 year Membership</option>
                    </select>
                  </div>
                  <div class="col-6 mb-3">
                    <label class="mb-0" for="loan-repay">Meeting Attendance</label>
                    <select v-model="meeting" id="loan-repay" class="form-select">
                      <option value="5">Perfect Attendance</option>
                      <option value="4">Occassional Absences</option>
                      <option value="2">Frequent Absences</option>
                      <option selected value="0">Rarely Attends</option>
                    </select>
                  </div>
                  <div class="col-6 mb-3">
                    <label class="mb-0" for="loan-repay">Purpose of Loan</label>
                    <select v-model="purpose" id="loan-repay" class="form-select">
                      <option value="5">Income-Generating Activities</option>
                      <option value="4">Essential Personal Needs</option>
                      <option value="2">Non-Essential Personal Use</option>
                      <option selected value="0">Undefined Purpose</option>
                    </select>
                  </div>
                  <div class="col-6 mb-3">
                    <label class="mb-0" for="loan-repay">Bank Statements</label>
                    <select v-model="bank_statements" id="loan-repay" class="form-select">
                      <option value="5">All Available</option>
                      <option value="3">Some Available</option>
                      <option selected value="0">No Available</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-1">
                    <button class="btn btn-danger" @click="clearFields">Reset</button>
                  </div>
                  <div class="col text-end">
                    <button :disabled="!member || form_loader" class="btn btn-outline-primary me-2"
                      @click.prevent="saveCreditReport">
                      <b-spinner small v-if="form_loader"></b-spinner>
                      Save <span v-if="backToLoanApplication">& Return to Loan Application</span>
                    </button>
                    <button :disabled="!member || form_loader" class="btn btn-primary"
                      @click.prevent="printSaveCreditReport">
                      <b-spinner small v-if="form_loader"></b-spinner>
                      Save & Print
                    </button>
                  </div>
                </div>
              </div>
              <div class="bg-white shadow-lg col-5 pt-3">
                <div class="">
                  <center>
                    <h3 class="mb-2"><u> Credit Score Meter </u></h3>
                    <VueSpeedMeter :customCurrentValue="customCurrentValue" :customStyle="{
                      size: 300,
                      mainBackgroundColor: '#FAF9F6',
                      borderColor: '#130F0B',
                      scaleColor: scaleColor,
                      scaleValuesColor: scaleColor,
                      scaleStartValue: 299,
                      scaleStep: 46,
                      needleColor: '#3F4140',
                      needleCircleColor: scaleColor,
                      needleCircleBorderColor: '#545454'
                    }" :needleAnimation="needleAnimation" :shadowFilter="shadowFilter" />
                    <div class="h2 text-center mb-0" style="position: relative; margin-top: -70px;"
                      :style="{ color: scaleColor }">
                      {{ customCurrentValue }}
                    </div>
                    <div style="position: relative; margin-top: -5px;">
                      {{ comment }}
                    </div>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View Credit Score</span></center>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import VueSpeedMeter from "vue-speed-meter";
import { memberMethods, memberComputed } from "@/state/helpers";

export default {
  page: {
    title: "Credit Score",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  components: {
    Layout,
    PageHeader,
    VueSpeedMeter
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Credit Score",
      items: [{ text: "Dashboard", to: "/", }, { text: "Credit Score", active: true, },],
      isBusy: true,
      role: '',
      permission: '',
      activeTab: 0,
      loan_repayment: 0,
      saving: 0,
      character: 0,
      capacity: 0,
      membership: 0,
      meeting: 0,
      purpose: 0,
      bank_statements: 0,
      comment: 'Poor',
      member: '',
      form_loader: false,

      //chart
      customCurrentValue: 300,
      customStyle: {
        size: 350,
        mainBackgroundColor: "white",
        borderColor: "grey",
        scaleColor: "grey",
        scaleValuesFontFamily: "'Old Standard TT', serif",
        scaleValuesColor: "grey",
        scaleStartValue: 299,
        scaleStep: 46,
        animationTime: 5,
        needleColor: "grey",
        needleCircleColor: "grey",
        needleCircleBorderColor: "grey",
      },
      needleAnimation: false,
      shadowFilter: false,
      backToLoanApplication: false,
    }
  },
  computed: {
    ...memberComputed,
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.permissions.map((d) => ({ ...d })) },
    IsBusy() { let a = false; if (this.permissions.length > 0) { a = false; } else { a = true; } return a },
    scaleColor() {
      let color = '';
      if (this.customCurrentValue >= 300 && this.customCurrentValue <= 528) {
        color = '#d62328';
      } else if (this.customCurrentValue >= 529 && this.customCurrentValue <= 650) {
        color = '#ee7726';
      } else if (this.customCurrentValue >= 651 && this.customCurrentValue <= 696) {
        color = '#e6c61d';
      } else if (this.customCurrentValue >= 697 && this.customCurrentValue <= 717) {
        color = '#b4b436';
      } else if (this.customCurrentValue >= 718 && this.customCurrentValue <= 743) {
        color = '#5ea744';
      } else if (this.customCurrentValue >= 744 && this.customCurrentValue <= 850) {
        color = '#108c59';
      }
      return color
    },

    scaleValue() {
      let total = Number(this.loan_repayment) + Number(this.saving) + Number(this.character) + Number(this.capacity) + Number(this.membership) + Number(this.meeting) + Number(this.purpose) + Number(this.bank_statements);
      let clampedTotal = Math.min(Math.max(total, 0), 100);
      let scaledValue = 300 + ((clampedTotal - 0) * (850 - 300)) / (100 - 0);

      return Math.floor(scaledValue);
    },

  },

  watch: {
    scaleValue() {
      this.createAnimatedScale()
      this.setComment()
    }
  },

  mounted() {
    if (this.$route.params.member) {
      this.member = this.$route.params.member
      this.backToLoanApplication = true
    }
    this.fetchMembers();
  },

  methods: {
    ...memberMethods,
    createAnimatedScale() {
      let interval = setInterval(() => {
        if (this.customCurrentValue < this.scaleValue) {
          this.customCurrentValue += 1;
        } else if (this.customCurrentValue > this.scaleValue) {
          this.customCurrentValue -= 1;
        } else {
          clearInterval(interval);
        }
      }, 10);
    },

    setComment() {
      if (this.scaleValue >= 300 && this.scaleValue <= 528) {
        this.comment = "Poor";
      } else if (this.scaleValue >= 529 && this.scaleValue <= 650) {
        this.comment = "Low";
      } else if (this.scaleValue >= 651 && this.scaleValue <= 696) {
        this.comment = "Fair";
      } else if (this.scaleValue >= 697 && this.scaleValue <= 717) {
        this.comment = "Good";
      } else if (this.scaleValue >= 718 && this.scaleValue <= 743) {
        this.comment = "Very Good";
      } else if (this.scaleValue >= 744 && this.scaleValue <= 850) {
        this.comment = "Excellent";
      }
    },

    async saveCreditReport() {
      this.form_loader = true

      const obj = {
        member_id: this.member.member_id,
        name: this.member.name,
        loan_repayment: this.loan_repayment,
        saving_history: this.saving,
        character: this.character,
        repayment_capacity: this.capacity,
        membership: this.membership,
        meeting_attendance: this.meeting,
        purpose: this.purpose,
        bank_statements: this.bank_statements,
        credit_score: this.scaleValue,
        comment: this.comment
      }

      await axios.post('/add-credit-report', obj)
        .then(() => {
          this.form_loader = false
          this.$toast.success('Credit Report Saved')
          if (this.backToLoanApplication) {
            this.$router.push({ name: 'loanapplication', params: { member: this.$route.params.member } })
          }
          else {
            this.$router.push('/credit-reports')
          }
        })
        .catch(() => {
          this.form_loader = false
          this.$toast.open({
            message: 'An error occurred. Please try again',
            type: 'error'
          })
        })
    },

    async printSaveCreditReport() {
      this.form_loader = true

      const obj = {
        member_id: this.member.member_id,
        name: this.member.name,
        loan_repayment: this.loan_repayment,
        saving: this.saving,
        character: this.character,
        capacity: this.capacity,
        membership: this.membership,
        meeting: this.meeting,
        purpose: this.purpose,
        bank_statements: this.bank_statements,
        credit_score: this.scaleValue,
        comment: this.comment
      }

      await axios.post('/add-credit-report', obj)
        .then((response) => {
          this.form_loader = false
          this.saving_balance = response.data.saving_balance
          this.$toast.success('Credit Report Saved')
          this.printCreditReport()
          this.clearFields()
        })
        .catch(() => {
          this.form_loader = false
          this.$toast.open({
            message: 'An error occurred. Please try again',
            type: 'error'
          })
        })
    },

    printCreditReport() {
      this.$router.push({
        name: 'creditreport', params: {
          member: {
            member_id: this.member.member_id,
            name: this.member.name
          },
          comment: this.comment,
          saving_balance: this.saving_balance,
          parameters: {
            'Loan Repayment History': this.loan_repayment,
            'Saving History': this.saving,
            'Character Assessment': this.character,
            'Capacity to Repay': this.capacity,
            'Duration of Membership': this.membership,
            'Meeting Attendance': this.meeting,
            'Purpose of Loan': this.purpose,
            'Availability of Bank Statements': this.bank_statements,
          }
        }
      })
    },

    clearFields() {
      this.loan_repayment = 0;
      this.saving = 0;
      this.character = 0;
      this.capacity = 0;
      this.membership = 0;
      this.meeting = 0;
      this.purpose = 0;
      this.bank_statements = 0;
    }
  },
};
</script>